import React from "react";
import { BrowserRouter } from "react-router-dom";

// Local components
import App from "./App";
import armTheme from "../styles/armTheme";

// Amplify components
import aws_exports from "../aws-exports";
import { Amplify } from "aws-amplify";
Amplify.configure(aws_exports);

// Material UI components
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from "@mui/material/styles";

// Material UI theme
const themeUI = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: armTheme.colours.primary.main,
    },
    secondary: {
      main: armTheme.colours.secondary.main,
    },
  },
}));

export default function Root() {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeUI}>
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}
